/* eslint-disable import/no-anonymous-default-export */
import { Button, Form, Input, InputRef, notification, Select, Modal } from "antd";
import { useForm } from "antd/es/form/Form";
import Checkbox from "antd/lib/checkbox/Checkbox";
import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { PictureFilled } from '@ant-design/icons';
import useCropPlate from "../hooks/useCropPlate";
import { ActionResult } from "../../common/hooks/useApi";
import { InfraccionesBrowserContext, InfraccionesBrowserContextProps } from "../../infracciones/components/InfraccionesBrowser";
import useLotesRenombradoAPI, { DatosRenombrado, DatosRenombradoSave } from "../hooks/useLotesRenombradoAPI";
import useCodigosInfraccionAPI, { CodigoInfraccion } from "../../codigos-infraccion/hooks/useCodigosInfraccionAPI";
import useDrawSvg from "../hooks/useDrawSvg";
import { PartialDeep } from "type-fest";
import { MaskedInput } from "antd-mask-input";
import moment, { duration } from 'moment';
import { InfoCircleOutlined } from '@ant-design/icons'
import _ from "lodash";
import useInfraccionesAPI, { DetectionAreas, DetectionData } from "../../infracciones/hooks/useInfraccionesAPI";
import VideoViewer from "./VideoViewer";
import InfoAtajosRenombrado from "./InfoAtajosRenombrado";


export interface RenombradoViewerProps {
    //infraccion: Infraccion
    renombrar: (id: number, data: PartialDeep<DatosRenombradoSave>) => Promise<ActionResult<any>>
    onSave?: (data: PartialDeep<DatosRenombrado>, context: InfraccionesBrowserContextProps) => any
    onBeforeSave?: (data: PartialDeep<DatosRenombrado>, context: InfraccionesBrowserContextProps) => any
    listCodigosInfraccion: (etiqueta: string) => Promise<ActionResult<CodigoInfraccion[]>>
};



const StyledOption = styled(Select.Option)`
white-space:initial;
`;

const FormContainer = styled(Form)`
display: grid;
grid-template-columns: 1fr 200px;
`;


const ImageColumn = styled.div`
`;

const ImageContainer = styled.div`
background: #212121;
padding-top: 56.25%;
position:relative;
`;

const InfraccionImg = styled.img`
position: absolute;
top: 0;
left: 0;
width: 100%;
height: 100%;
`;

const FormColumn = styled.div`
padding: 1rem;
display: flex;
flex-direction: column;
justify-content: space-between;
background:#e0e0e0;
`;

const InputContainer = styled.div`
display: grid;

`;

const ImageSelectorContainer = styled.div`
display:flex;
gap:0.5rem;
`;

const ImageSelector = styled.div`

& > span {
    background: #616161;
    position: relative;
    padding: 0.25rem 0.5rem;
    font-size: 1.2rem;
    color: white;
    cursor:pointer;
    
}

&:not(.selected) > span
{
    opacity: 0.4;
}
`;

const StyledCanvas = styled.canvas`
border: 1px dashed;
width:100%;
background-color:#bdbdbd;
margin-bottom:0.5rem;
`;

const PlaceholderIcon = styled(PictureFilled)`
color: white;
position: absolute;
top: 50%;
left: 50%;
transform: translateX(-50%) translateY(-50%);
/* transform: translateY(-50%); */
font-size: 3rem;
`;

const CurrentPlateCut = styled.img`
margin-bottom: 1rem;
`;

const Svg = styled.svg`
position: absolute;
top: 0;
left: 0;
width: 100%;
height: 100%;
`;

const HiddenValidationItem = styled(Form.Item)`
.ant-form-item-explain {
    display:none!important;
  }
`;
const CustomValidationItem = styled(HiddenValidationItem)`
&.ant-form-item-has-error input 
{
  border: 1px solid #ff4d4f;
}
&.ant-form-item-with-help
{
  margin-bottom:24px;
}
`;

const DetectionArea = styled.div`
  position: absolute;
  border: 2.5px solid red;
  box-sizing: border-box;
`;

const ImageBottom = styled.div`
padding: 1rem;
background: #bdbdbd;
display: flex;
justify-content: space-between;
`;

const TextoModo = styled.span<{ mode: ('RECORTE' | 'OCULTAR') }>`
text-align: center;
font-weight: 600;
font-size: 0.8rem;
margin-top: 1rem;
color: ${props => props.mode == 'OCULTAR' ? '#388e3c' : '#0277bd'};
`;

const patenteWidth = 400;
const patenteHeight = 250;

export default (props: RenombradoViewerProps) => {
    const browserContext = useContext(InfraccionesBrowserContext);
    const apiInfracciones = useInfraccionesAPI();
    const apiRenombrado = useLotesRenombradoAPI();
    const svgRef = useRef<SVGSVGElement>(null);
    const canvasRef = useRef<HTMLCanvasElement>(null);
    const imgRef = useRef<HTMLImageElement>(null);
    const inputPatenteRef = useRef<InputRef>(null);
    const [form] = useForm<PartialDeep<DatosRenombrado>>();
    const [renombradoData, setRenombradoData] = useState<PartialDeep<DatosRenombrado>>({
        Extranjero: browserContext.infraccion.Extranjero,
        ImagenDestacadaIndice: browserContext.infraccion.ImagenDestacadaIndice ?? 0,
        Patente: browserContext.infraccion.Patente,
        PatenteIlegible: !browserContext.infraccion.Patente && browserContext.infraccion.Estado == 'RENOMBRADA',
        PatenteX: browserContext.infraccion.PatenteX,
        PatenteY: browserContext.infraccion.PatenteY,
        PatenteZoom: browserContext.infraccion.PatenteZoom,
        FechaHora: moment(browserContext.infraccion.FechaHora).format("DD/MM/YYYY HH:mm:ss"),
        //FechaHora: moment(browserContext.infraccion.ImagenPatente?.FullUrl.toString()).format("DD/MM/YYYY HH:mm:ss"),
        //Si la infracción no tiene un codigo de infraccion seteado uso el predefinido en el equipo, y sino, dejo no definido
        CodigoInfraccionId: browserContext.infraccion.CodigoInfraccionId ??
            browserContext.infraccion.Equipo.ConfiguracionProduccion.CodigoInfraccionId ??
            undefined,
        Overlays: browserContext.infraccion.OverlaysImagenes ?? [],
        //@ts-ignore
        EtiquetasImagenes: _.chain(browserContext.infraccion.EtiquetasImagenes)
            //@ts-ignore
            .map(v => ({ Nombre: v.Etiqueta.Nombre, EtiquetaIndex: v.EtiquetaIndex }))
            .keyBy('EtiquetaIndex')
            .value(),
        Lugar: browserContext.infraccion.Lugar ?? browserContext.infraccion.Equipo?.Lugar,
        NoDistinguible: browserContext.infraccion.NoDistinguible,
    });
    const [loading, setLoading] = useState(false);
    const [codigosInfraccionResponse, setCodigosInfraccionResponse] = useState<ActionResult<CodigoInfraccion[]>>();
    const { crop, changeZoom, decrementZoom, incrementZoom, generateFile } = useCropPlate();
    const [drawMode, setDrawMode] = useState<"RECORTE" | "OCULTAR">("RECORTE");
    const [isModalAtajosVisible, setIsModalAtajosVisible] = useState<boolean>(false)
    const [visibleIndex, setVisibleIndex] = useState(0);
    const [modalVideoVisible, setModalVideoVisible] = useState<boolean>(false)
    const [idImagenDestacada, setIdImagenDestacada] = useState<string>();
    const [areasDeteccionImg, setAreasDeteccionImg] = useState<DetectionAreas | null>(null);
    const [ codigosRenombrado, setCodigosRenombrado ] = useState<{Id: number, Abreviatura: string | undefined}[]>([]);

    // const checkRenombradoExists = async () => {
    //     let renombradoExist;
    //     let infraction = browserContext.infraccion;
    //     let date = moment(infraction.FechaHora!, "YYYY-MM-DDTHH:mm:ss").format();
    //     let dateCompareBefore = moment(date).subtract(1, "minutes").format();
    //     let dateCompareAfter = moment(date).add(1, "minutes").format();

    //     const filters = [
    //         `Patente eq '${renombradoData.Patente}' and Lugar eq '${renombradoData.Lugar}' and CodigoInfraccionId eq ${renombradoData.CodigoInfraccionId} and equipoId eq ${infraction.Equipo.Id} and FechaHora ge ${dateCompareBefore} and FechaHora le ${dateCompareAfter}`,
    //     ];

    //     const response = await apiInfracciones.list({
    //         $count: true,
    //         $top: 1,
    //         $filter: filters,
    //     });

    //     if (response.error) {
    //         notification.error({ message: "Error al validar el renombrado de la infraccion" });
    //         return;
    //     }

    //     response.data?.["@odata.count"]! > 0 ? renombradoExist = true : renombradoExist = false

    //     if (response.data?.value.length !== 0) {
    //         if (response.data?.value[0].Id === browserContext.infraccion.Id) {
    //             renombradoExist = false;
    //         }
    //     }

    //     return renombradoExist;
    // };

    useEffect(() => {
        initOverlay();
        if (renombradoData.PatenteX && renombradoData.PatenteY)
            imgRef.current!.onload = () => {
                if (!canvasRef.current) {
                    return;
                }
                crop(renombradoData.PatenteX!, renombradoData.PatenteY!, patenteWidth, patenteHeight, imgRef.current!, canvasRef.current!, renombradoData.PatenteZoom);
            } //cropPlate(renombradoData.PatenteX!, renombradoData.PatenteY!);
        setVisibleIndex(renombradoData.ImagenDestacadaIndice ?? 0);
        setIdImagenDestacada(browserContext.infraccion.Imagenes![0].Id.toString());
        props.listCodigosInfraccion(browserContext.infraccion.Equipo.ConfiguracionProduccion.EtiquetaCodigoInfracciones).then(setCodigosInfraccionResponse);
        form.setFieldsValue(renombradoData);

        /*
        let mousePosition;
        const onScroll = (e:MouseEvent)=>{
           
        }

        const onMouseMove = (e:MouseEvent)=>{
            console.log(e)
        }
        
        document.addEventListener('scroll',(e)=>);
        document.addEventListener('mousemove',onMouseMove);

        return ()=>document.removeEventListener('scroll',onScroll);*/

    }, []);

    useEffect(() => {
        let array = [...codigosRenombrado];
        codigosInfraccionResponse?.data?.value.map(e => {
            let obj = { Id: e.Id, Abreviatura: e.Abreviatura !== null ? e.Abreviatura : e.Descripcion }
            array.push(obj);
        });
        setCodigosRenombrado(array);
    }, [codigosInfraccionResponse]);
    
    useEffect(() => {
        const overlayIndex = getOverlayIndex(visibleIndex);
        setSvgXml(svgRef.current!, overlayIndex != undefined ? renombradoData.Overlays![overlayIndex]!.Svg! : "");
    }, [visibleIndex]);

    const getEtiquetasImagenes = _.memoize(() => {
        return codigosInfraccionResponse?.data?.value
            .filter(c => c.Id == (renombradoData.CodigoInfraccionId ?? browserContext.infraccion.Equipo.ConfiguracionProduccion.CodigoInfraccionId))
            .at(0)
            ?.EtiquetasImagenes ?? [];
    });

    const initOverlay = () => {
        const index = getOverlayIndex();
        setSvgXml(svgRef.current!, index != undefined ? renombradoData.Overlays![index]!.Svg! : "");
    }

    const changeSelectedImage = (index: number /*evt: React.KeyboardEvent<HTMLDivElement>*/) => {
        setRenombradoData({ ...renombradoData, ...{ ImagenDestacadaIndice: index } });
        setVisibleIndex(index);
        setIdImagenDestacada(browserContext.infraccion.Imagenes![index].Id.toString())
    };

    const moveNextImage = () => {
        setVisibleIndex((visibleIndex + 1) % browserContext.infraccion.Imagenes!.length);
        setRenombradoData({ ...renombradoData, ...{ ImagenDestacadaIndice: (visibleIndex + 1) % browserContext.infraccion.Imagenes!.length } });
    }

    const verifyFormatPatente = (values: Partial<DatosRenombrado>) => {
        const regexPatente = /^[A-Z]{3}[0-9]{3}$|^[A-Z]{2}[0-9]{3}[A-Z]{2}$|^[0-9]{3}[A-Z]{3}$|^[A-Z][0-9]{3}[A-Z]{3}$/;
        if (!renombradoData.PatenteIlegible && !regexPatente.test(renombradoData.Patente!)) {
            Modal.confirm({
                title: "Formato de patente incorrecto",
                content: "¿Desea continuar con el formato incorrecto o corregirlo?",
                maskClosable: false,
                okText: "Continuar",
                cancelText: "Corregir",
                onOk: () => {
                    saveRenombrado(values as Partial<DatosRenombrado>);
                },
                onCancel: () => {
                    inputPatenteRef.current?.focus();
                    return;
                },
            });
        } else {
            saveRenombrado(values as Partial<DatosRenombrado>);
        }
    };

    const saveRenombrado = async (values: Partial<DatosRenombrado>) => {
        if (renombradoData.ImagenDestacadaIndice === undefined) {
            Modal.error({ title: "No hay imagen destacada", content: "Seleccione la imagen más representativa de la infracción" });
            return;
        }
        //Si la cantidad de etiquetas es la misma que la de imágenes, debo seleccionar una por imagen
        if (browserContext.infraccion.Imagenes?.length == getEtiquetasImagenes().length &&
            Object.values(renombradoData?.EtiquetasImagenes ?? {}).length != browserContext.infraccion.Imagenes?.length) {
            notification.warn({
                message: "Seleccione una etiqueta para todas las imágenes",
                placement: 'bottomRight'
            });
            return;
        }

        if (!renombradoData?.PatenteX && !renombradoData?.PatenteY && !browserContext.infraccion.ImagenPatente) {
            notification.warn({
                message: 'Seleccione el recorte de la patente',
                placement: 'bottomRight'
            })
            return;
        }

        // if (renombradoData?.Patente && !renombradoData?.PatenteIlegible) {
        //     const renombradoExist = await checkRenombradoExists();

        //     if (renombradoExist) {
        //         notification.warn({
        //             message: "La infraccion ya ha sido renombrada",
        //             placement: "bottomRight",
        //         });
        //         return;
        //     }
        // }

        setLoading(true);
        const data = { ...renombradoData, ...{ FechaHora: moment(renombradoData.FechaHora!, "DD/MM/YYYY HH:mm:ss", true).toISOString() }, ...{ NoDistinguible: renombradoData.PatenteIlegible ? true : false } };
        props.onBeforeSave?.(data, browserContext);

        browserContext.queue.push(async () => {

            const recortePatente = await generateFile();
            const response = await props.renombrar(
                browserContext.infraccion.Id,
                { ...data, ...{ ArchivoPatente: recortePatente ?? undefined, EtiquetasImagenes: JSON.stringify(data.EtiquetasImagenes ?? {}) } }
            ) //api.renombrar(props.infraccion.Id, renombradoData);
            if (response.error) {
                notification.error({ message: "Error al renombrar" });
                setLoading(false);
                return;
            }

            if (browserContext.infraccion.Estado == 'PENDIENTE') browserContext.incrementTodayStatisticsValue();
            await browserContext.refreshInfraccion();
            setLoading(false);

            props.onSave?.(data, browserContext);
        });
    };

    const selectPlateArea = async (evt: React.MouseEvent<SVGElement, MouseEvent>) => {
        const PatenteX = Math.round(imgRef.current!.naturalWidth * (evt.nativeEvent.offsetX / imgRef.current!.width));
        const PatenteY = Math.round(imgRef.current!.naturalHeight * (evt.nativeEvent.offsetY / imgRef.current!.height));

        //cropPlate(PatenteX, PatenteY);
        const PatenteZoom = crop(PatenteX, PatenteY, patenteWidth, patenteHeight, imgRef.current!, canvasRef.current!);

        setRenombradoData({ ...renombradoData, ...{ PatenteX, PatenteY, PatenteZoom } });
        inputPatenteRef.current?.focus()
    };

    const changePlateZoom = (e?: React.WheelEvent<SVGElement>) => {
        let PatenteZoom;
        if (e?.deltaY! < 0) {
            PatenteZoom = incrementZoom();
        }
        else {
            PatenteZoom = decrementZoom();
        }
        setRenombradoData({ ...renombradoData, ...{ PatenteZoom } });
    }

    const coverArea = (evt: React.MouseEvent<SVGElement, MouseEvent>) => {
        drawRect(svgRef.current!, evt);
    }

    const getOverlayIndex = (currentIndex?: number) => {
        const imagen = browserContext.infraccion.Imagenes![currentIndex ?? visibleIndex];
        let overlayIndex = renombradoData.Overlays!.findIndex(o => o!.ImagenId == imagen.Id);
        return overlayIndex > -1 ? overlayIndex : undefined;
    };

    const updateOverlays = (Svg: string, index?: number) => {
        const overlayIndex = getOverlayIndex();

        const newOverlays = [...renombradoData.Overlays!];
        const newOverlay = { Svg, InfraccionId: browserContext.infraccion.Id, ImagenId: browserContext.infraccion.Imagenes![renombradoData.ImagenDestacadaIndice!].Id };

        if (overlayIndex != undefined) {
            newOverlays[overlayIndex] = {
                ...newOverlays[overlayIndex],
                ...newOverlay
            };
        }
        else {
            newOverlays.push(newOverlay);
        }
        setRenombradoData({
            ...renombradoData,
            ...{
                Overlays: newOverlays
            }
        })
    };

    const onMouseDown = (evt: React.MouseEvent<SVGElement, MouseEvent>) => {
        onSvgMouseDown(evt, svgRef.current!);
        coverArea(evt);
    };

    //Arma las etiquetas por defecto: asigna una etiqueta única a cada imagen que no tenga,
    //respetando las que el usuario ya haya seleccionado. Solo es necesario cuando la cantidad
    //de etiquetas configuradas coincide con la cantidad de imágenes (caso en que el guardado las exige).
    const buildDefaultEtiquetas = () => {
        const etiquetas = getEtiquetasImagenes();
        const imagenes = browserContext.infraccion.Imagenes ?? [];
        const current = { ...(renombradoData.EtiquetasImagenes ?? {}) };

        if (etiquetas.length === 0 || imagenes.length !== etiquetas.length) {
            return current;
        }

        const usados = Object.values(current).map(e => e?.Nombre).filter(Boolean);
        const disponibles = etiquetas.map(e => e.Nombre).filter(n => !usados.includes(n));

        imagenes.forEach((_img, index) => {
            if (!current[index]?.Nombre) {
                const nombre = disponibles.shift();
                if (nombre) current[index] = { Nombre: nombre };
            }
        });

        return current;
    };

    const discardInfraccion = async () => {

        setLoading(true);
        const data = {
            ...renombradoData,
            ...{
                FechaHora: renombradoData.FechaHora && moment(renombradoData.FechaHora, "DD/MM/YYYY HH:mm:ss", true).isValid()
                    ? moment(renombradoData.FechaHora, "DD/MM/YYYY HH:mm:ss", true).toISOString()
                    : new Date().toISOString(),
                ImagenDestacadaIndice: renombradoData.ImagenDestacadaIndice ?? 0,
                EtiquetasImagenes: buildDefaultEtiquetas()
            },
            ...{ NoDistinguible: true, PatenteIlegible: true, Patente: undefined }
        };
        props.onBeforeSave?.(data, browserContext);

        browserContext.queue.push(async () => {

            const recortePatente = await generateFile();
            const response = await props.renombrar(
                browserContext.infraccion.Id,
                { ...data, ...{ ArchivoPatente: recortePatente ?? undefined, EtiquetasImagenes: JSON.stringify(data.EtiquetasImagenes ?? {}) } }
            )
            if (response.error) {
                notification.error({ message: "Error al renombrar" });
                setLoading(false);
                return;
            }

            if (browserContext.infraccion.Estado == 'PENDIENTE') browserContext.incrementTodayStatisticsValue();
            await browserContext.refreshInfraccion();
            setLoading(false);

            props.onSave?.(data, browserContext);
        });
    }

    window.onkeydown = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            form.submit()
        } else if (e.key === "F10") {
            e.preventDefault();
            const button = document.getElementById("extranjero-btn");
            button?.click();
        } else if (e.key === "F12") {
            e.preventDefault();
            discardInfraccion();
        } else if (e.key === "ArrowLeft") {
            e.preventDefault();
            browserContext.goBackward();
        } else if (e.key === "ArrowRight") {
            e.preventDefault();
            browserContext.goForward();
        } else if (e.key === "F2") {
            e.preventDefault();
            moveNextImage();
        } else if (e.ctrlKey && e.key === "p") {
            e.preventDefault();
            inputPatenteRef.current?.focus();
        }
    }

    const isEtiquetaImagenRequired = _.memoize(() => {
        return (browserContext.infraccion.Imagenes?.length ?? 0) >= getEtiquetasImagenes().length &&
            Object.values(renombradoData.EtiquetasImagenes ?? {})
                .filter(e => e?.Nombre).length < getEtiquetasImagenes().length;
    });

    const handleCaptureImageFromVideo = (file: File, image: any) => {
        if (file && image) {
            Modal.confirm({
                title: "Se ha tomado una captura del video",
                content: `¿Desea subir una nueva imagen de la infracción con la captura del video?`,
                maskClosable: false,
                okText: "Continuar",
                cancelText: "Cancelar",
                onOk: () => {
                    handleReplaceImagenInfraccion(file);
                },
                onCancel: () => {
                    return;
                },
            });
        }
    };

    const handleReplaceImagenInfraccion = async (file: File) => {
        notification.info({ message: "Cargando imagen..", duration: 12 })
        const response = await apiRenombrado.replaceImageDestacada(idImagenDestacada!?.toString(), browserContext.infraccion.Id.toString(), file);
        if (response) {
            notification.success({ message: 'Imagen cargada a la infracción..' })
            setModalVideoVisible(false)
        }
        await browserContext.refreshInfraccion();
    }

    useEffect(() => {
        inputPatenteRef.current?.focus()
        if (browserContext.infraccion.AreasDeteccionImagenes) {
            const areasDeteccionData = JSON.parse(browserContext.infraccion.AreasDeteccionImagenes);
            const invertedAreasDeteccionData = Object.values(areasDeteccionData).reverse();
            const invertedAreasDeteccionImg: DetectionAreas = {};
            invertedAreasDeteccionData.forEach((area, index) => {
                invertedAreasDeteccionImg[(index + 1).toString()] = area as DetectionData;
            });

            setAreasDeteccionImg(invertedAreasDeteccionImg);
        }
    }, []);

    const { drawRect, setSvgXml, onSvgMouseDown } = useDrawSvg({ onDraw: updateOverlays });

    return (
        <>
            <Modal
                onOk={() => {
                    setIsModalAtajosVisible(false)
                }}
                okText={"Aceptar"}
                cancelButtonProps={{ style: { display: 'none' } }}
                width={"90%"}
                style={{ maxWidth: "768px" }}
                visible={isModalAtajosVisible}
                onCancel={() => {
                    setIsModalAtajosVisible(false)
                }}
            >
                <InfoAtajosRenombrado />
            </Modal>

            {browserContext.infraccion.Videos?.length! > 0 && <Modal
                visible={modalVideoVisible}
                onCancel={() => setModalVideoVisible(false)}
                footer={null}
                width={1200}
            >
                {/* <VideoViewer videoUrl={browserContext.infraccion.Videos![0].FullUrl} imagenPatenteUrl={browserContext.infraccion.ImagenPatente?.FullUrl}/> */}
                <VideoViewer videoUrl={browserContext.infraccion.Videos![0].FullUrl} onCapture={handleCaptureImageFromVideo} />
            </Modal>
            }
            <FormContainer
                form={form}
                onFieldsChange={() => setRenombradoData({ ...renombradoData, ...form.getFieldsValue() })}
                onFinish={(values) => verifyFormatPatente(values as Partial<DatosRenombrado>)}
            >
                {browserContext.infraccion.Imagenes?.map((imagen, index) =>
                    <ImageColumn key={index} style={{ display: visibleIndex == index ? 'block' : 'none' }}>
                        <ImageContainer>
                            <PlaceholderIcon />
                            <InfraccionImg className="infraccion-img" id={`img-${imagen.Id}`} crossOrigin="anonymous" ref={visibleIndex == index ? imgRef : undefined} src={imagen.FullUrl} />
                            <DetectionArea
                                key={index}
                                style={{
                                    top: areasDeteccionImg && areasDeteccionImg[index + 1] ? `${(areasDeteccionImg[index + 1].top * 100).toFixed(2)}%` : '',
                                    left: areasDeteccionImg && areasDeteccionImg[index + 1] ? `${(areasDeteccionImg[index + 1].left * 100).toFixed(2)}%` : '',
                                    width: areasDeteccionImg && areasDeteccionImg[index + 1] ? `${(areasDeteccionImg[index + 1].width * 100).toFixed(2)}%` : '',
                                    height: areasDeteccionImg && areasDeteccionImg[index + 1] ? `${(areasDeteccionImg[index + 1].height * 100).toFixed(2)}%` : '',
                                }}

                            />
                            <Svg
                                viewBox="0 0 100 100"
                                preserveAspectRatio="none"
                                onContextMenu={(evt) => evt.preventDefault()}
                                ref={visibleIndex == index ? svgRef : undefined}
                                onWheel={drawMode == 'RECORTE' ? changePlateZoom : undefined}
                                onClick={drawMode == 'RECORTE' ? selectPlateArea : undefined}
                                onMouseDown={drawMode == 'OCULTAR' ? onMouseDown : undefined}

                            >
                            </Svg>
                        </ImageContainer>
                        <ImageBottom>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                {getEtiquetasImagenes()
                                    .filter(e => renombradoData.EtiquetasImagenes?.[index]?.Nombre || !Object.values(renombradoData.EtiquetasImagenes ?? {}).map(e => e!.Nombre!).includes(e.Nombre))
                                    .length > 0 &&
                                    <HiddenValidationItem
                                        style={{ marginBottom: 0 }}
                                        name={["EtiquetasImagenes", index.toString(), "Nombre"]}
                                        rules={[{
                                            required: isEtiquetaImagenRequired()
                                        }]}
                                        label="Etiqueta"
                                    >
                                        <Select
                                            allowClear
                                            style={{ width: 'auto', minWidth: '100px' }}
                                        >
                                            {getEtiquetasImagenes()
                                                .filter(e => !Object.values(renombradoData.EtiquetasImagenes ?? {}).map(e => e!.Nombre!).includes(e.Nombre))
                                                .map(e => <Select.Option key={e.Nombre} value={e.Nombre}>{e.Nombre}</Select.Option>)}
                                        </Select>
                                    </HiddenValidationItem>
                                }
                                {(browserContext.infraccion.Imagenes?.length ?? 0) > 1 && <Checkbox
                                    id={"Imgdestacada-btn"}
                                    checked={index == renombradoData.ImagenDestacadaIndice}

                                    onChange={(e) => setRenombradoData({ ...renombradoData, ...{ ImagenDestacadaIndice: e.target.checked ? index : undefined } })}
                                >Imagen destacada</Checkbox>}
                            </div>

                            <ImageSelectorContainer>
                                {browserContext.infraccion.Imagenes!.map((image, i) =>
                                    <ImageSelector
                                        key={i}
                                        onClick={() => changeSelectedImage(i)}
                                        className={i == index ? "selected" : ""}>
                                        <span>{i + 1}</span>
                                    </ImageSelector>)}
                            </ImageSelectorContainer>
                        </ImageBottom>
                    </ImageColumn>
                )}
                <FormColumn
                >
                    {/*
                    <ImageSelectorContainer>
                        {browserContext.infraccion.Imagenes!.map((image, index) =>
                            <ImageSelector key={index} onClick={() => changeSelectedImage(index)} className={index == renombradoData.ImagenDestacadaIndice ? "selected" : ""}>
                                <span>{index + 1}</span>
                            </ImageSelector>)}
                    </ImageSelectorContainer>*/}


                    <InputContainer>
                        {browserContext.infraccion.ImagenPatente &&
                            <CurrentPlateCut src={browserContext.infraccion.ImagenPatente.FullUrl} />}

                        <StyledCanvas ref={canvasRef}></StyledCanvas>

                        <HiddenValidationItem
                            dependencies={["PatenteIlegible"]}
                            rules={[
                                { required: !renombradoData.PatenteIlegible, message: "Campo requerido" }
                                // validator(rule, value, callback) {
                                //     let regexPatente = new RegExp("^([a-zA-Z]{2,3}[0-9]{3}[a-zA-Z]{0,2})?$");
                                //     callback(regexPatente.test(value) ? undefined : "Patente incorrecta")
                                //   }
                            ]}

                            normalize={(value, prevValue, allValues) => value.toUpperCase()}
                            style={{ marginBottom: 5 }}
                            name={"Patente"}>
                            <Input
                                ref={inputPatenteRef}
                                autoFocus
                                disabled={renombradoData.PatenteIlegible}
                                autoComplete={"off"}
                                placeholder="Patente" />
                        </HiddenValidationItem>

                        <HiddenValidationItem
                            rules={[
                                { required: true, message: "Campo requerido" }
                            ]}

                            normalize={(value, prevValue, allValues) => value.toUpperCase()}
                            style={{ marginBottom: 5 }}
                            name={"Lugar"}>
                            <Input
                                autoComplete={"off"}
                                placeholder="Lugar" />
                        </HiddenValidationItem>

                        {/* {!browserContext.infraccion.Equipo.ConfiguracionProduccion.CodigoInfraccionId &&
                            
                        } */}

                        <HiddenValidationItem
                        name={"CodigoInfraccionId"}
                        required
                        style={{ marginBottom: 5 }}
                        rules={[{
                            required: true,
                            message: ""
                        }]}
                        >                            
                            <Select
                                showSearch
                                placeholder="Tipo de infracción"
                                optionFilterProp="key"
                            >
                                {codigosRenombrado.map((c) =>
                                    <Select.Option key = {c.Id} value = {c.Id}><p style = {{ whiteSpace: "initial" }}>{ c.Abreviatura }</p></Select.Option>
                                )}
                            </Select>
                        </HiddenValidationItem>

                        <CustomValidationItem
                            name={"FechaHora"}
                            hasFeedback
                            required
                            rules={[
                                {
                                    validator(rule, value, callback) {
                                        callback(moment(value, "DD/MM/YYYY HH:mm:ss", true).isValid() ? undefined : "Fecha inválida");
                                    }
                                }
                            ]}
                            //initialValue={renombradoData.ArchivoPatente?.name?.toString()}
                            //initialValue={browserContext.infraccion.ImagenPatente?.FullUrl.toString()}
                            initialValue={renombradoData.FechaHora}
                        >
                            <MaskedInput
                                placeholder="Fecha y hora"
                                mask={"00/00/0000 00:00:00"}
                            />
                        </CustomValidationItem>

                        <HiddenValidationItem
                            valuePropName="checked"
                            name={"Extranjero"}
                            style={{ marginBottom: 0 }} >
                            <Checkbox id="extranjero-btn" >Extranjero</Checkbox>
                        </HiddenValidationItem>

                        <HiddenValidationItem

                            valuePropName="checked"
                            name={"PatenteIlegible"}
                            style={{ marginBottom: 10 }} >
                            <Checkbox id="ilegible-btn" onChange={(event) => event.target.checked && form.setFieldsValue({ Patente: undefined })}>Patente ilegible</Checkbox>
                        </HiddenValidationItem>

                        <Button id="renombrar-btn" loading={loading} disabled={!(renombradoData?.PatenteX && renombradoData?.PatenteY) && !browserContext.infraccion.ImagenPatente} type="primary" htmlType="submit">Renombrar</Button>

                        <Button id="descartar-btn" danger loading={loading} onClick={discardInfraccion} style={{ marginTop: "0.5rem", fontWeight: 'bold' }}>Descartar (F12)</Button>

                        {browserContext.infraccion.Videos?.length! > 0 &&
                            <Button onClick={() => setModalVideoVisible(!modalVideoVisible)} style={{ marginTop: "0.5rem", fontWeight: 'bold' }} type="default">Video infracción</Button>
                        }

                        <Button style={{ marginTop: "0.5rem" }} onClick={() => setDrawMode(drawMode == "RECORTE" ? "OCULTAR" : "RECORTE")}>
                            <strong>{drawMode == "RECORTE" ? "Activar ocultar" : "Activar recorte"}</strong>
                        </Button>
                        <Button onClick={() => setIsModalAtajosVisible(true)} type="default" icon={<InfoCircleOutlined />} size="small" style={{ marginTop: "0.5rem", color: "var(--primary-color)" }}>
                            Ver atajos de teclado
                        </Button>

                        <TextoModo mode={drawMode} >Modo {drawMode == 'RECORTE' ? 'recorte' : 'ocultar'} activado</TextoModo>
                    </InputContainer>
                </FormColumn>

            </FormContainer >
        </>
    );
};